import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Notification, NotificationType, NotificationAlertType } from 'ah-api-gateways';
import NotificationCard from './NotificationCard.vue';
import { formatDistance, isSameDay, isToday, isYesterday } from 'date-fns';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useNotificationState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsList',
  props: {
    maxItems: { default: 0 },
    withUpdatesNotification: { type: [Boolean, String], default: false },
    simple: { type: [Boolean, String], default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { maxItems: number, withUpdatesNotification: boolean | string, simple: boolean | string };



const notificationState = useNotificationState();

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

const showNewUpdatesNotification = computed(() => {
  return (
    props.withUpdatesNotification !== false && notificationState.store.useNotificationsStore().updateUnreadCount > 0
  );
});

const hasMoreNotifications = computed(() => {
  return (
    notificationState.store.useNotificationsStore().allCount > notifications.value.length &&
    (props.maxItems === 0 || props.maxItems > notifications.value.length)
  );
});

const notifications = computed(() => {
  const out: Notification[] = [];

  if (showNewUpdatesNotification.value) {
    out.push({
      id: 'updateNotification',
      title: 'There are have been updates to X-Hedge',
      message: 'We have updated X-Hedge to improve your experience.',
      type: NotificationType.SOFTWARE_IMPROVEMENTS,
      read: true,
      createdAt: new Date().toISOString(),
      alertType: NotificationAlertType.REGULAR,
    });
  }

  out.push(
    ...(props.maxItems > 0
      ? notificationState.store
          .useNotificationsStore()
          .notifications.slice(0, showNewUpdatesNotification.value ? props.maxItems - 1 : props.maxItems)
      : notificationState.store.useNotificationsStore().notifications)
  );

  return out;
});

const noNotifications = computed(() => !notifications.value || notifications.value.length === 0);

function onRetryFromParentManager(k: string) {
  if (k === 'loadNotifications') {
    loadMoreItems();
  }
}

function viewResource(item: Notification) {
  notificationState.viewNotificationResource && notificationState.viewNotificationResource(item);
}

function onInfiniteLoad(intersection: IntersectionObserverEntry) {
  if (intersection.isIntersecting) {
    loadMoreItems();
  }
}

function isSameDayAs(a: Notification, b: Notification) {
  return isSameDay(new Date(a.createdAt), new Date(b.createdAt));
}

function loadMoreItems() {
  requestManager.manager.newPromise(
    'loadNotifications',
    notificationState.store.useNotificationsStore().loadSidebarNotifications()
  );
}

function markAsRead(notification: Notification) {
  notificationState.store.useNotificationsStore().markAsRead(notification);
}

function formatDate(date: string) {
  if (isToday(new Date(date))) {
    return 'TODAY';
  } else if (isYesterday(new Date(date))) {
    return 'YESTERDAY';
  }

  return formatDistance(new Date(date), new Date(), { addSuffix: true });
}

if (notifications.value.length === 0) {
  loadMoreItems();
}

expose({ noNotifications });

return { __sfc: true,props, notificationState, requestManager, showNewUpdatesNotification, hasMoreNotifications, notifications, noNotifications, onRetryFromParentManager, viewResource, onInfiniteLoad, isSameDayAs, loadMoreItems, markAsRead, formatDate, NotificationCard }
}

})